//INIT
$(document).ready(init())

// GLOBALS
var discountCode
var discountValue
var discountNumber

function init() {
  console.log("running miku-product.js")
  waitForElementToDisplay('.bv-content-pagination-pages-current', 100)
  initChangeHandlers()
  getWallMountQuantity()
  getPowerQuantity()  
  getStandQuantity()
  getCaseQuantity()
  getCartAttributes()
  discountData = getDiscount()
}

function initChangeHandlers() {
  
  $( "#addCouponCheckbox" ).change(function() {
    var isChecked = $( "#addCouponCheckbox" ).is(":checked")
    var attrs = {
      attributes: {
        applyCoupon: isChecked,
        discountCode: discountCode,
        discountValue: discountValue,
        discountNumber: discountNumber
      }
    }
    $.post('/cart/update.js', attrs);  
  })
  
  $( "#addWallMountCheckbox" ).change(function() {
    addAddOn(31668026081398, "#addWallMountCheckbox")
  });  
  
  $( "#addStandCheckbox" ).change(function() {
    addAddOn(29514687316086, "#addStandCheckbox")
  });  

  $( "#addCaseAndPowerCheckbox" ).change(function() {
    addAddOn(31395319152758, "#addCaseAndPowerCheckbox")
  });  

  $( "#addPowerCheckbox" ).change(function() {
    addAddOn(31442653347958, "#addPowerCheckbox")
  });    
  
  $('#Quantity').change(function() {
    var addon = $("#addPowerCheckbox").is(":checked")
    if (addon) {    
      updateAddOnQuantity(31442653347958)
    }
  });   
  
  $('#Quantity').change(function() {
    var addon = $("#addCaseAndPowerCheckbox").is(":checked")
    if (addon) {    
      updateAddOnQuantity(31395319152758)
    }
  });  

  $('#Quantity').change(function() {
    var addon = $("#addStandCheckbox").is(":checked")
    if (addon) {    
      updateAddOnQuantity(31395319152758)
    }
  });  
  
}

function waitForElementToDisplay(selector, time) {
  if(document.querySelector(selector)!=null) {
    var reviewAmount = $('.bv-content-pagination-pages-current').text()  
    var reviewStats = "<b>4.7</b> &nbsp;" + reviewAmount.split("of")[1].split("Reviews")[0] + ' Reviews'
    $('.review-numbers').html(reviewStats)       
    return;
  }
  else {
    
    setTimeout(function() {
      waitForElementToDisplay(selector, time);
    }, time);
  }
}

var plyrInstanceVideo = new Plyr('#productVideo')

// Function to reveal lightbox and play video
function revealVideo(div,video_id) {
  plyrInstanceVideo.volume = 0.5
  $('.main-content').css({opacity: '.1'})
  $('#shopify-section-header').css({opacity: '.1'})
  $('footer').css({opacity: '1'})  
  document.getElementById(div).style.display = 'block';
  plyrInstanceVideo.play()
  
}

// Hiding the lightbox and pause video
function hideVideo(div,video_id) {
  $('.main-content').css({opacity: '1'})
  $('#shopify-section-header').css({opacity: '1'})  
  $('footer').css({opacity: '1'})
  document.getElementById(div).style.display = 'none';
  plyrInstanceVideo.pause()
}


function getWallMountQuantity() {
  $.get('/products/wall-mount-kit-for-miku-smart-baby-monitor.js',  
        function (data, textStatus, jqXHR) {  // success callback
    if (textStatus == 'success') {
      let json = JSON.parse(data)
      if (json.variants[0].available) {
        $(".wallmount-container").css('display', 'flex')
      }
    }
  }); 
}


function getStandQuantity() {
  $.get('/products/miku-floor-stand.js',  
        function (data, textStatus, jqXHR) {  // success callback
    if (textStatus == 'success') {
      let json = JSON.parse(data)
      if (json.variants[0].available) {
        $(".stand-container").css('display', 'flex')
      }
    }
  }); 
}


function getCaseQuantity() {
  $.get('/products/travel-case-power-supply.js',  
        function (data, textStatus, jqXHR) {  // success callback
    if (textStatus == 'success') {
      let json = JSON.parse(data)
      if (json.variants[0].available) {
        $(".case-container").css('display', 'flex')
      }
    }
  }); 
}

function getPowerQuantity() {
  $.get('/products/power-supply-10-feet.js',  
        function (data, textStatus, jqXHR) {  // success callback
    if (textStatus == 'success') {
      let json = JSON.parse(data)
      if (json.variants[0].available) {
        $(".powersupply-container").css('display', 'flex')
      }
    }
  }); 
}  
  

function addAddOn(variantId, selector, updated) {
  var addon = $(selector).is(":checked")
  if (addon) {
    $.post('/cart/add.js', {
      items: [
        {
          quantity: $('#Quantity').val(),
          id: variantId
        }
      ]
    });  
  } else {
    $.post('/cart/update.js', {updates: {[variantId]: 0}});       
  }

}

function updateAddOnQuantity(variantId) {
  $.post('/cart/update.js', {updates: {[variantId]: $('#Quantity').val()}})
}

function getNum(s) {
  var r = /\d+/g;
  var m;
  while ((m = r.exec(s)) != null) {
    return m[0]
  }
}

// TODO: get price rules
// Update product page content with active promotion coupoun checkbox
function getDiscount() {
  $.get('https://api.mikucare.com/amp/banner', function(data, textStatus, jqXHR) {
  	console.log(data, textStatus)
    discountCode = data.items[0].discountCode
    discountValue = data.items[0].discountValue
    discountNumber = getNum(data.items[0].discountValue)
    if (discountCode && discountValue) {
      $(".discount-container").css('display', 'flex')
      $("#discountValue").text(discountValue)
    }
  }) 
}

function getCartAttributes() {
  $.get('/cart.js', function (data, textStatus, jqXHR) { 
    var jsonData = JSON.parse(data)
  	console.log(jsonData.attributes.applyCoupon, textStatus)
    if (jsonData.attributes.applyCoupon == 'true') {
    	$("#addCouponCheckbox").prop( "checked", true )
    }
  })
}